export default __webpack_public_path__ + "6fb2ee5a90569f4bed29ea1cb83561c7.svg";